import {
  Box,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Tooltip,
} from "@mui/material";

import { useTranslation } from "react-i18next";
import EditIcon from "@mui/icons-material/Edit";

import React, { useEffect, useState } from "react";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { ImageGalleryRow } from "../../../../components/CustomComponents/ImageGalleryRow/ImageGalleryRow";
import { FeatureTableRow } from "../../Components/FeatureTableRow";
import { CustomTextField } from "../../../../components/modals/FloatingWindow/Components/FeatureForm/Components/CustomTextField";
import { updateGridStatus } from "../../../../api/ApiGrid";
// import { ImageGalleryRow } from "../../../components/CustomComponents/ImageGalleryRow/ImageGalleryRow";
// import { FeatureTableRow } from "./FeatureTableRow";

export const GridFeatureLayer = ({ feature: f, tableRef }) => {
  const { t } = useTranslation("main");
  const feature = f[0];
  const [imageHeight, setImageHeight] = useState(200);
  const minImageHeight = 80;
  const maxImageHeight = 200;
  const [selectedImage, setSelectedImage] = useState(0);
  const imgUrls = extractImageLinks(feature?.properties);
  const [gridStatus, setGridStatus] = useState(feature?.properties?.status);
  const [editGridStatus, setEditGridStatus] = useState(false);

  useEffect(() => {
    const adjustImageSize = () => {
      if (tableRef.current) {
        const maxScroll =
          tableRef.current.scrollHeight - tableRef.current.clientHeight;
        const scrollTop = tableRef.current.scrollTop;
        const scrollFactor = scrollTop / maxScroll; // Normaliza el scroll entre 0 y 1

        // Reduce la imagen progresivamente hasta su mínimo
        const newImageHeight =
          maxImageHeight - (maxImageHeight - minImageHeight) * scrollFactor;
        setImageHeight(newImageHeight);
      }
    };

    const tableDiv = tableRef.current;
    if (tableDiv) {
      tableDiv.addEventListener("scroll", adjustImageSize);
    }

    return () => {
      if (tableDiv) {
        tableDiv.removeEventListener("scroll", adjustImageSize);
      }
    };
  }, []);

  const propertiesToOmit = [
    "status",
    "uuid",
    "layer_uuid",
    // "id",
    // "value",
    // "shape_length",
    // "district_tx",
    // "major_neighborhood",
    // "district_bar_code",
    // "neighborhood_number",
    // "neighborhood_mt",
    // "district_b_code",
    // "image_url",
    // "risk_simplify_type",
    // "risk_form_value",
  ];

  function extractImageLinks(obj) {
    let imageLinks = [];

    function searchImages(value) {
      if (
        typeof value === "string" &&
        value.match(
          /^https?:\/\/.*\.(jpg|jpeg|png|gif|webp|bmp|svg|tiff)(\?.*)?$/i
        )
      ) {
        imageLinks.push(value);
      } else if (typeof value === "object" && value !== null) {
        Object.values(value).forEach(searchImages);
      }
    }

    searchImages(obj);
    return imageLinks;
  }

  // const handlePrevImage = () => {
  //   setSelectedImage((prev) => (prev === 0 ? imgUrls.length - 1 : prev - 1));
  // };

  // const handleNextImage = () => {
  //   setSelectedImage((prev) => (prev === imgUrls.length - 1 ? 0 : prev + 1));
  // };

  const handleChangeGridStatus = () => (e) => {
    const newGridStatus = e.target.value;
    updateGridStatus(feature.properties.uuid, newGridStatus);
    setEditGridStatus(false);
    setGridStatus(newGridStatus);
  };

  // const isGridStatus = feature.layer_type === "GRID" && field === "status";

  return (
    <>
      <TableContainer
        component={Paper}
        style={{
          boxShadow: "none",
          padding: "0",
          overflow: "visible",
          ...(imgUrls?.length > 0 && { marginTop: "calc(200px + 1rem)" }),
        }}
      >
        <Table aria-label="feature table">
          <TableBody>
            <TableRow
              key={`${feature?.id}-status`}
              sx={{
                "&:nth-of-type(odd)": { backgroundColor: "#f5f5f5" }, // Color más oscuro solo en filas pares
                "&:last-child td, &:last-child th": { border: 0 },
              }}
            >
              <TableCell component="th" scope="row">
                {t("status")}
              </TableCell>
              <TableCell>
                {editGridStatus ? (
                  <CustomTextField
                    field="status"
                    value={gridStatus}
                    onChange={handleChangeGridStatus}
                    options={["PENDING", "IN_REVIEW", "REVIEWED", "CLEAR"]}
                    disableClear
                  />
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      gap: "1rem",
                      alignItems: "center",
                    }}
                  >
                    <span>{t(gridStatus)}</span>

                    <Tooltip title={t("edit")}>
                      <IconButton
                        onClick={() => {
                          setEditGridStatus(true);
                        }}
                        size="small"
                        sx={{ p: 0 }}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </Box>
                )}
              </TableCell>
            </TableRow>
            {Object.entries(feature?.properties)
              .filter(([key]) => !propertiesToOmit.includes(key))
              .map(([field, value]) => {
                if (typeof value === "object" || !value) return null;

                return (
                  <FeatureTableRow
                    selectedFeature={feature}
                    field={field}
                    value={value}
                  />
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};
